import React from "react";
import { useApi } from "common/utils/api";
import { useSnackbarAlerts } from "./Snackbar";
import { ADMIN_ACTIONS } from "../admin/store/reducers/root";
import {
  UPDATE_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS_WITH_BUSINESS_TYPE
} from "common/utils/apiQueries/admin";

export const useUpdateCompanyDetails = (
  company,
  adminStore,
  handleAfterSubmit
) => {
  const api = useApi();
  const alerts = useSnackbarAlerts();

  const [newCompanyName, setNewCompanyName] = React.useState(company?.name);
  const [newCompanyPhoneNumber, setNewCompanyPhoneNumber] = React.useState(
    company?.phoneNumber
  );
  const [newCompanyBusinessType, setNewCompanyBusinessType] = React.useState(
    { transportType: adminStore.business?.transportType || "", businessType: adminStore.business?.businessType || "" }
  );
  const [newNbWorkers, setNewNbWorkers] = React.useState(
    company?.nbWorkers || null
  );

  const hasBusinessTypeChanged = React.useMemo(
    () =>
      newCompanyBusinessType?.businessType !== adminStore.business?.businessType ||
      newCompanyBusinessType?.transportType !== adminStore.business?.transportType,
    [newCompanyBusinessType, adminStore.business?.businessType, adminStore.business?.transportType]
  );

  const isBusinessTypeComplete = React.useMemo(
    () =>
      !newCompanyBusinessType?.transportType ||
      !!newCompanyBusinessType?.businessType,
    [newCompanyBusinessType]
  );

  const updateCompanyDetails = async (applyBusinessTypeToEmployees) => {
    await alerts.withApiErrorHandling(async () => {
      const apiResponse = await api.graphQlMutate(
        hasBusinessTypeChanged
          ? UPDATE_COMPANY_DETAILS_WITH_BUSINESS_TYPE
          : UPDATE_COMPANY_DETAILS,
        {
          companyId: company?.id,
          newName: newCompanyName || null,
          newPhoneNumber: newCompanyPhoneNumber || null,
          newNbWorkers: newNbWorkers || null,
          ...(hasBusinessTypeChanged
            ? {
                newBusinessType: newCompanyBusinessType?.businessType,
                newTransportType: newCompanyBusinessType?.transportType,
                applyBusinessTypeToEmployees
              }
            : {})
        },
        { context: { nonPublicApi: false } }
      );

      const id = apiResponse?.data?.updateCompanyDetails?.id;
      const business = apiResponse?.data?.updateCompanyDetails?.business;
      const name = apiResponse?.data?.updateCompanyDetails?.name;
      const phoneNumber = apiResponse?.data?.updateCompanyDetails?.phoneNumber;
      const nbWorkers = apiResponse?.data?.updateCompanyDetails?.nbWorkers;
      await adminStore.dispatch({
        type: ADMIN_ACTIONS.updateCompanyNameAndPhoneNumber,
        payload: {
          companyId: id,
          companyName: name,
          companyPhoneNumber: phoneNumber,
          companyNbWorkers: nbWorkers
        }
      });
      await adminStore.dispatch({
        type: ADMIN_ACTIONS.updateBusinessType,
        payload: {
          business
        }
      });
      if (hasBusinessTypeChanged) {
        const employments =
          apiResponse?.data?.updateCompanyDetails?.employments;
        for (const employment of employments) {
          await adminStore.dispatch({
            type: ADMIN_ACTIONS.update,
            payload: {
              id: employment.id,
              entity: "employments",
              update: {
                ...employment,
                companyId: id,
                adminStore
              }
            }
          });
        }
      }
      alerts.success(
        "Les détails de l'entreprise ont bien été enregistrés",
        "",
        6000
      );
      handleAfterSubmit();
    }, "update-company-details");
  };
  return {
    newCompanyName,
    setNewCompanyName,
    newCompanyPhoneNumber,
    setNewCompanyPhoneNumber,
    setNewCompanyBusinessType,
    hasBusinessTypeChanged,
    isBusinessTypeComplete,
    updateCompanyDetails,
    newCompanyBusinessType,
    newNbWorkers,
    setNewNbWorkers
  };
};
